import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class Mbp3Service {

  constructor( private httpService: HttpService) { }

  addMbpData(object) {
      var request = {
          URL: "mbp3/mbpEntry",
          DATA: object
      }
      return this.httpService.post(request);
  }

  getMbpList(object) {
      var request = {
          URL: "mbp3/getMbpList/5cee33d225242e023acfb2d4",
          DATA: object
      }
      return this.httpService.post(request);
  }

  getMbpById(_id) {
      var request = {
          URL: "mbp3/getMBPDetailsById/" + _id,
      }
      return this.httpService.get(request);
  }

  updateMbpData(id, object) {
      var request = {
          URL: "mbp3/updateMbpData/" + id,
          DATA: object
      }
      return this.httpService.post(request);
  }

  deleteMbpData(_id) {
      var request = {
          URL: "mbp3/deletMbpDetail/" + _id
      }
      return this.httpService.get(request);
  }

  generateMbp3Document(object) {
      var request = {
          URL: "mbp3/generateMbp3Document",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadMbp3File(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "mbp3/downloadDocument/" + id + "/" + type +"/"+token;
  }
  downloadMbp3PdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "mbp3/downloadPdfDocument/" + id + "/" + type +"/"+token;
  }

}